import React, { useState } from 'react'
import { useEffect } from 'react'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IPoll, IQuestion } from '../../../api/types'
import EmptyPollFragment from './EmptyPollFragment/EmptyPollFragment'
import QuestionFragment from './QuestionFragment/QuestionFragment'

const emptyQuestion: IQuestion = {
    uuid: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    hasCorrectOption: false,
    image: '',
    selectOptionsLimitation: 1,
    position: 0,
    title: '',
    userMayChangeVote: false,
    options: [],
}

type Props = {
    poll: IPoll
}

const PollScreen: FC<Props> = ({ poll }) => {
    const { t } = useTranslation()
    const [isLoaded, setIsLoaded] = useState(false)
    const [question, setQuestion] = useState<IQuestion>(emptyQuestion)

    useEffect(() => {
        if (poll.questions.length > 0) {
            setQuestion(poll.questions[0]) // hardcoded, because current concept must support only single quesiton poll
            setIsLoaded(true)
        }
    }, [poll])

    if (!isLoaded) {
        return (
            <EmptyPollFragment
                title={poll.title}
                imageUrl={poll.image}
                text={t('no-questions-in-pull')}
            />
        )
    }
    return <QuestionFragment pollID={poll.uuid} pollTitle={poll.title} question={question} />
}

export default PollScreen
